module.exports = __webpack_public_path__ + "img/83.e373b262.jpg";